import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/store/index.ts";

type envChecklistState = {
  location: {
    locationId: string;
    locationName: string;
  };
  auditDate: Date | undefined;
  auditType: "day" | "residential" | undefined;
};

const initialState: envChecklistState = {
  location: {
    locationId: "",
    locationName: "",
  },
  auditDate: undefined,
  auditType: undefined,
};

const envChecklistSlice = createSlice({
  name: "envChecklist",
  initialState,
  reducers: {
    setLocation: (state, action: PayloadAction<string>) => {
      state.location.locationId = action.payload;
    },
    setLocationName: (state, action: PayloadAction<string>) => {
      state.location.locationName = action.payload;
    },
    setAuditDate: (state, action: PayloadAction<Date>) => {
      state.auditDate = action.payload;
    },
    setAuditType: (state, action: PayloadAction<"day" | "residential">) => {
      state.auditType = action.payload;
    },
    resetEnvChecklist: () => initialState,
  },
});

export const {
  setLocation,
  setLocationName,
  setAuditDate,
  setAuditType,
  resetEnvChecklist,
} = envChecklistSlice.actions;
export const selectLocationId = (state: RootState) =>
  state.envChecklistForm.location.locationId;
export const selectLocation = (state: RootState) =>
  state.envChecklistForm.location;
export const selectEnvChecklistData = (state: RootState) =>
  state.envChecklistForm;

export const envChecklistReducer = envChecklistSlice.reducer;
